export function createPlayPlaceholder(width: number, height: number, quality: number): HTMLImageElement {
    const safeWidth = Math.max(1, Math.floor(width || 320));
    const safeHeight = Math.max(1, Math.floor(height || 180));

    const placeholderCanvas = document.createElement('canvas');
    placeholderCanvas.width = safeWidth;
    placeholderCanvas.height = safeHeight;

    const ctx = placeholderCanvas.getContext('2d');
    if (ctx) {
        ctx.fillStyle = '#000';
        ctx.fillRect(0, 0, safeWidth, safeHeight);

        const radius = Math.max(16, Math.min(safeWidth, safeHeight) * 0.14);
        const centerX = safeWidth / 2;
        const centerY = safeHeight / 2;

        ctx.fillStyle = 'rgba(255, 255, 255, 0.22)';
        ctx.beginPath();
        ctx.arc(centerX, centerY, radius, 0, Math.PI * 2);
        ctx.fill();

        ctx.fillStyle = '#fff';
        ctx.beginPath();
        ctx.moveTo(centerX - radius * 0.28, centerY - radius * 0.45);
        ctx.lineTo(centerX - radius * 0.28, centerY + radius * 0.45);
        ctx.lineTo(centerX + radius * 0.55, centerY);
        ctx.closePath();
        ctx.fill();
    }

    const img = document.createElement('img');
    img.src = placeholderCanvas.toDataURL('image/jpeg', quality);
    img.style.width = `${safeWidth}px`;
    img.style.height = `${safeHeight}px`;

    return img;
}
